import { Center, type CenterProps } from '@chakra-ui/react'

import logger from '@/utils/logger'

import { getPartnerLogoURL, getPartnershipsUrl } from '@/client/services/url'

import OptimizedImage from '@/components/PublicImage/OptimizedImage'
import ShwLink from '@/components/ShwLink'

import type { PartnerLogoItem } from './types'

export default function PartnerLogo({
  partner,
  greyscale = false,
  scaleMultiplier = 1,
  linkToPartnershipsPage = false,
  ...centerProps
}: {
  partner: PartnerLogoItem
  greyscale?: boolean
  scaleMultiplier?: number
  linkToPartnershipsPage?: boolean
} & CenterProps): JSX.Element {
  const { logoSrc, greyscaleLogoSrc, width, height, displayWidth, href } = partner
  if (greyscale && greyscaleLogoSrc == null) {
    logger.warning(
      `Attempting to use greyscale logo for PartnerLogo when it doesn't exist. Using #${logoSrc} instead.`
    )
  }
  const image = (
    <OptimizedImage
      src={getPartnerLogoURL(greyscale && greyscaleLogoSrc != null ? greyscaleLogoSrc : logoSrc)}
      originalWidth={width}
      originalHeight={height}
      displayWidth={[
        `${displayWidth * scaleMultiplier * 0.55}px`,
        `${displayWidth * scaleMultiplier * 0.85}px`,
        `${displayWidth * scaleMultiplier}px`,
      ]}
      alt={partner.name ?? ''}
    />
  )

  return (
    <Center padding={[1, 2]} {...centerProps}>
      {linkToPartnershipsPage || href != null ? (
        <ShwLink href={linkToPartnershipsPage ? getPartnershipsUrl() : href} isExternal>
          {image}
        </ShwLink>
      ) : (
        image
      )}
    </Center>
  )
}
